export type { TrailInfoListSectionProps } from "./trail-info-list";
export { TrailInfoListSection } from "./trail-info-list";
